export default "<p>property-summary works!</p>\n"